const footerCatAccordion = () => {

    const acc = document.querySelectorAll(".cat-accordion h3");
    const accList = document.querySelectorAll(".cat-accordion ul");
    const accParent = document.querySelector(".cat-accordion");
    let i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.parentElement.classList.toggle("cat-acc-open");
        });
    }

    for (i = 0; i < accList.length; i++) {
        if(accList[i].innerHTML === ""){
            accList[i].parentElement.style.display = "none";
        }
    }
}

export default footerCatAccordion;